import { Component } from '@angular/core';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsConst } from '../../../globals/WsConst';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsService } from '../../../services/websocket/WsService';
import { SuperClass } from '../../../superclass/SuperClass';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-data',
  templateUrl: './data.component.html',
  styleUrls: ['./data.component.css'],
})
export class DataComponent extends SuperClass {
  subscription;

  dashboardData;
  dataUsage;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Usage Statistics' },
      { label: 'Data', routerLink: [{ outlets: { sub: [RouterConst.DATA] } }] },
    ]);
  }

  setData(data) {
    this.dashboardData = data;
    this.chartsInit();
  }

  reloadData() {
    this.dashboardDataService.getDD('DataComponent');
  }

  getWebSocketIdentifier() {
    return WsConst.STATISTICS;
  }

  chartsInit() {
    this.dataUsage = {
      labels: [
        '01:00',
        '03:00',
        '05:00',
        '07:00',
        '09:00',
        '11:00',
        '13:00',
        '15:00',
        '17:00',
        '19:00',
        '21:00',
        '23:00',
      ],
      datasets: [
        {
          label: this.dashboardData.charts.dataUsage.label1,
          data: this.dashboardData.charts.dataUsage.data1,
          fill: false,
          borderColor: '#4bc0c0',
        },
        {
          label: this.dashboardData.charts.dataUsage.label2,
          data: this.dashboardData.charts.dataUsage.data2,
          fill: false,
          borderColor: '#565656',
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/usage_statistics/data/data.component.ts